(function () {
    'use strict';

    // FormController has a $setUntouched method, but not a $setTouched method.
    // It should have one and I need it to have one, so I'm adding it here.

    angular
        .module(app.modules.common.name)
        .decorator('formDirective', formDirectiveDecorator)
        .decorator('ngFormDirective', formDirectiveDecorator);

    formDirectiveDecorator.$inject = ['$delegate'];
    function formDirectiveDecorator($delegate) {
        var formController = $delegate[0].controller;
        if (!formController.prototype.$setTouched)
            formController.prototype.$setTouched = $setTouched;
        return $delegate;
    }

    function $setTouched() {
        angular.forEach(this, function (value, key) {
            if (angular.isFunction(value && value.$setTouched) && key != '$$parentForm')
                value.$setTouched();
        });
    };
})();